export default __webpack_public_path__ + "de3ad641b7de83c1a945463975a8d2e8.jpg";